import React from "react";
import "react-dropdown/style.css";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ur1 from "../assets/logo-large.jpg";
import { newPassword, fetchUser as fetchAuthUser } from "../common/slices/auth";
import { fetchUser } from "../common/slices/user";
import { pathNames } from "../constants";
import { BlackButton } from "./Buttons";
import FormPasswordInput from "./FormPasswordInput";
import Row from "./Row";
import { H1, P } from "./Typography";

const Form = styled.div`
    display: flex;
    gap: 1rem;
    background: white;
    padding: 0 5rem;
    flex-direction: column;
    min-width: 300px;
    max-width: 500px;
    border-left: 1px solid #b9b9b9;

    @media(max-width: 920px) {
        border-left: none;
        flex: 1;
    }
`;

const Container = styled(Row)`
    flex: 1;
    background: white;
    align-items: center;
    justify-content: center;
    display: flex;
    gap: 5rem;

    @media(max-width: 920px) {
        flex-wrap: wrap;
        align-content: center;
    }
`;

const Logo = styled.img`
    display: flex;
    flex-shrink: 0;
    align-self: center;
`;

const NewPassword = () => {
    const dispatch = useDispatch();
    const nav = useNavigate();
    const {
        control,
        handleSubmit,
        setError,
        formState: { errors, isValid, isSubmitting },
    } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
    });

    const formFields = { control, errors };

    const onSubmit = async ({ password }) => {
        try {
            const { isSignedIn } = await dispatch(newPassword(password));
            if (isSignedIn) {
                const profile = await dispatch(fetchUser());
                await dispatch(fetchAuthUser());
                profile.role === 'ADMIN' ?
                    nav(pathNames.SAFETYFORMS) :
                    nav(pathNames.ACCESSDENIED);
            } else {
                nav(pathNames.ACCESSDENIED);
            }
        } catch (ex) {
            setError("password", { message: ex.message });
        }
    };

    return (
        <Container>
            <Logo src={ur1} style={{ height: '200px' }} />
            <Form>
                <H1>New Password</H1>
                <P>New password is required.  Use the form below to set your permanent password.</P>
                <FormPasswordInput {...formFields} name="password" label="New Password" placeholder="Enter new password" rules={{ required: true }} />
                <BlackButton onClick={handleSubmit(onSubmit)} disabled={!isValid || isSubmitting}>
                    Set Password
                </BlackButton>
            </Form>
        </Container>
    );
};

export default NewPassword;
